var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCodeScanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 70.4375H26.9531V26.9531H70.4375V70.4375Z",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.875 43.4844V54.2656",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4375 157.047H26.9531V113.562H70.4375V157.047Z",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.875 129.734V140.516",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.047 70.4375H113.562V26.9531H157.047V70.4375Z",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.484 43.4844V54.2656",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2510_18684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.82 183.82V0.179688H0.179688V183.82H183.82Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.359375
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2510_18684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 54.2656V5.39062H54.2656",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.094 5.39062H178.609V54.2656",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 129.734V178.609H54.2656",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.094 178.609H178.609V129.734",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.875 113.562H113.562V140.516",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.172 157.047H157.047V129.734",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.047 86.6094V118.953",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.484 129.734V157.047",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92 162.438V92H140.875",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 92H43.4844",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2656 92H75.8281",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75.8281V21.5625",
    stroke: "black",
    strokeWidth: 10.7812,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    y: 0,
    height: 8,
    fill: "#FF0000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;100%",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 7,
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "0;100%",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeScanner);
export default __webpack_public_path__ + "static/media/qr-code-scanner.63484898cef7c94f321378095a40e776.svg";
export { ForwardRef as ReactComponent };